<h2 mat-dialog-title i18n>EDIT INITIAL TRANSITION</h2>
<mat-dialog-content>
<form #formElement
      id="workflow-initial-transition-form"
      [formGroup]="model.form">
    <fieldset>
        <mat-form-field appearance="outline">
            <mat-label i18n>Selected Role(s)</mat-label>
            <mat-select formControlName="roles" [compareWith]="compareOptionsByID" multiple required>
                <mat-optgroup *ngFor="let group of model.roles" [label]="group.name">
                    <mat-option *ngFor="let role of group.items" [value]="role" [title]="role.name">{{ role.name }}</mat-option>
                </mat-optgroup>
            </mat-select>
            <mat-hint i18n>Which role(s) can initiate this booking?</mat-hint>
            <mat-error *ngIf="shouldShowError('roles')" i18n>Please select at least one role.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label i18n>Transition name</mat-label>
            <input matInput
                   formControlName="name"
                   placeholder="Type name of the action role performs..."
                   required
                   readonly>
            <mat-hint i18n>This will be the name of the primary action button for a user to initiate this booking.</mat-hint>
            <mat-error *ngIf="shouldShowError('name')" i18n>Please provide a name for the transition.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label i18n>Workflow will begin in this state</mat-label>
            <mat-select formControlName="target" [compareWith]="compareOptionsByID" required>
                <mat-option *ngFor="let state of model.states" [value]="state">{{ state.name }}</mat-option>
            </mat-select>
            <mat-hint align="start" i18n>When initiated the booking will enter this state.</mat-hint>
            <mat-hint *ngIf="model.canRenameTarget" align="end">
                <a (click)="model.startRenameTargetState()" tabindex="-1" i18n>Rename state</a>
            </mat-hint>
            <mat-error *ngIf="shouldShowError('target')" i18n>You must select end state.</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="model.isAddingTarget"
                        appearance="outline"
                        class="left-padding"
                        floatLabel="always">
            <mat-label i18n>New state name</mat-label>
            <input matInput
                   formControlName="targetNew"
                   placeholder="Type name of the state"
                   required>
            <mat-error *ngIf="shouldShowError('validTargetState')"></mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="model.isRenamingTarget"
                        appearance="outline"
                        class="left-padding"
                        floatLabel="always">
            <mat-label i18n>The {{ model.form.value.target.name }} state will be renamed to</mat-label>
            <input matInput
                   formControlName="targetNew"
                   placeholder="Type new name for the state"
                   required>
            <button mat-icon-button matSuffix
                    (click)="model.cancelRenameTargetState()"
                    aria-label="Cancel renaming"
                    [attr.aria-pressed]="cancel"
                    i18n-aria-label>
                <mat-icon>cancel</mat-icon>
            </button>
            <mat-error *ngIf="shouldShowError('validTargetState')"></mat-error>
        </mat-form-field>
    </fieldset>
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button tabindex="-1" (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button type="submit"
                            (click)="onSave()"
                            color="primary"
                            [disabled]="!model.valid()"
                            i18n>Apply</button>
</mat-dialog-actions>
